"use strict";
window.SHIGETA_PAGE = window.SHIGETA_PAGE || {};

(function($$) {
  function setupStoreList() {
    let wrapperElement = document.querySelector('#pgStore');
    if(!wrapperElement) return;

    let currentData = {
          area: null,
          type: null
        },
        triggersObj = {
          area: wrapperElement.querySelectorAll('[data-target-area]'),
          type: wrapperElement.querySelectorAll('[data-target-type]')
        },
        selectObj = {
          area: wrapperElement.querySelector('select[data-name="area"]'),
          type: wrapperElement.querySelector('select[data-name="type"]')
        },
        contentElementAll = wrapperElement.querySelectorAll('[data-area], [data-type]');

    const toggleContent = (targetData) => {
      // コンテンツの表示判定・切り替え
      [...contentElementAll].forEach((contentElement) => {
        let hiddenFlag = false;
        for(let targetKey of Object.keys(targetData)) {
          let targetValue = targetData[targetKey],
              hasContentValue = contentElement.hasAttribute(`data-${targetKey}`);
          if(targetValue !== null && hasContentValue) {
            let contentValue = contentElement.getAttribute(`data-${targetKey}`),
                isMatched = (targetValue === 'all' || contentValue.split(',').includes(targetValue));
            if(!isMatched) {
              hiddenFlag = true;
              break;
            }
          }
        }
        if(hiddenFlag) {
          contentElement.classList.add('pg-u-d--n');
        } else {
          contentElement.classList.remove('pg-u-d--n');
        }
      });

      Object.keys(targetData).forEach((targetKey) => {
        let targetValue = targetData[targetKey],
            isChanged = targetValue !== currentData[targetKey];

        if(isChanged) {
          // トリガー要素のアクティブ状態を変更
          let triggerElementAll = triggersObj[targetKey] || [];
          [...triggerElementAll].forEach((triggerElement) => {
            let triggerValue = triggerElement.getAttribute(`data-target-${targetKey}`);
            if(targetValue === triggerValue) {
              triggerElement.classList.add('pg-is-active');
            } else {
              triggerElement.classList.remove('pg-is-active');
            }
          });

          // セレクト要素の選択状態を更新
          let selectElement = selectObj[targetKey];
          if(selectElement && selectElement.value !== targetValue) {
            selectElement.value = targetValue;
          }

          // 現在の値を更新
          currentData[targetKey] = targetValue;
        }
      });
    }

    // トリガー要素での切り替え（for PC）
    Object.keys(triggersObj).forEach((triggerKey) => {
      let triggerElementAll = triggersObj[triggerKey];
      [...triggerElementAll].forEach((triggerElement) => {
        let triggerValue = triggerElement.getAttribute(`data-target-${triggerKey}`);
        triggerElement.addEventListener('click', (e) => {
          let targetData = {
            area: (triggerKey === 'area' ? triggerValue : currentData.area),
            type: (triggerKey === 'type' ? triggerValue : currentData.type)
          };
          toggleContent(targetData);
        });
      });
    });

    // セレクト要素での切り替え（for SP）
    Object.keys(selectObj).forEach((selectKey) => {
      let selectElement = selectObj[selectKey];
      if(selectElement) {
        selectElement.addEventListener('change', (e) => {
          let selectValue = selectElement.value;
          let targetData = {
            area: (selectKey === 'area' ? selectValue : currentData.area),
            type: (selectKey === 'type' ? selectValue : currentData.type)
          };
          toggleContent(targetData);
        });
      }
    });

    // 初期化
    if($$.fn.isSP()) {
      Object.keys(selectObj).forEach((selectKey) => {
        let selectElement = selectObj[selectKey];
        if(selectElement) {
          selectElement.dispatchEvent(new Event('change'));
        }
      });
    } else {
      Object.keys(triggersObj).forEach((triggerKey) => {
        let triggerElementAll = triggersObj[triggerKey];
        if(triggerElementAll && triggerElementAll[0]) {
          triggerElementAll[0].dispatchEvent(new Event('click'));
        }
      });
    }

    // ブレイクポイント切り替え時
    window.addEventListener($$.event.switchBreakpoint, (e) => {
      if($$.fn.isPC()) {
        if(selectObj.type && selectObj.type.value === 'all' && triggersObj.type && triggersObj.type[0]) {
          triggersObj.type[0].dispatchEvent(new Event('click'));
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', (e) => {
    setupStoreList();
  });
})(window.SHIGETA_PAGE);